import $ from 'jquery';
import Cache from 'root/cache';
import Form from 'root/module/form';
import View from 'view/base';
import Modals from 'root/modals';

var position_text = {
    'top_left'    : ['at', 'upper-left corner'],
    'top'         : ['in', 'upper middle'],
    'top_right'   : ['at', 'upper-right corner'],
    'left'        : ['on', 'left side'],
    'center'      : ['in', 'middle'],
    'right'       : ['on', 'right side'],
    'bottom_left' : ['at', 'lower-left corner'],
    'bottom'      : ['in', 'lower middle'],
    'bottom_right': ['at', 'lower-right corner'],
};

var sizes = ['smaller', 'small', 'medium', 'large', 'larger'];

export default View.extend({
    events: {
        'click .format .radio-box'                   : 'onClickFormat',
        'click .position-select > div'               : 'onSelectPosition',
        'change input[name="survey_size"]'           : 'updateSettings',
        'click .survey-alignment .radio-box'         : 'onClickAlignment',
        'input input[name="highlight_colour"]'       : 'updateSettings',
        'input input[name="complement_colour"]'      : 'updateSettings',
        'change input[name="has_background_colour"]' : 'onChangeIsBackgroundUsed',
        'input input[name="background_colour"]'      : 'updateSettings',
        'input input[name="background_colour_alpha"]': 'updateSettings',
        'change input[name="hide_powered_by"]'       : 'updateSettings',
        'click .account-upgrade'                     : 'accountUpgrade',
    },

    dom_handlers: {
        onClickFormat: function(e) {
            var value = $(e.currentTarget).data('val');

            this.$el.find('.format .radio-box').removeClass('selected');
            this.$el.find(`.format .radio-box[data-val="${value}"]`).addClass('selected');

            this.$el.find('.format-tips span').removeClass('active');
            this.$el.find(`.format-tips span[data-val="${value}"]`).addClass('active');

            this.updateSettings();
        },
        onSelectPosition: function(e) {
            var value = $(e.currentTarget).data('val');

            this.$el.find('.position-select > div').removeClass('selected');
            this.$el.find(`.position-select > div[data-val="${value}"]`).addClass('selected');

            this.$el.find('.position-tips span').eq(0).text(position_text[value][0]);
            this.$el.find('.position-tips span').eq(1).text(position_text[value][1]);

            this.updateSettings();
        },
        updateSettings: function(e) {
            this.updateSettings();
        },
        onClickAlignment: function(e) {
            var value = $(e.currentTarget).data('val');

            this.$el.find('.survey-alignment .radio-box').removeClass('selected');
            this.$el.find(`.survey-alignment .radio-box[data-val="${value}"]`).addClass('selected');

            this.updateSettings();
        },
        onChangeIsBackgroundUsed: function(e) {
            const value = $(e.currentTarget).prop('checked');

            this.$el.find('.background-colour').toggleClass('active', value);

            this.updateSettings();
        },
        accountUpgrade: function(e) {
            Modals.choosePlan();
        }
    },

    event_handlers: {
        onFormatChange: function() {
            this.togglePositionSection();
            this.toggleSizeSection();
        },
        onPositionChange: function() {
            this.toggleSizeSection();
        },
    },

    getSettings: function() {
        var form_data = Form.getData(this.$el);
        var survey_size_value = form_data.survey_size;
        var survey_size = sizes[survey_size_value - 1];

        var has_background_colour = form_data.has_background_colour[0] === 1;

        // TODO:need to discuss how to store the 'background_color'. add a new column or separate it with comma
        var background_colour = form_data.background_colour_alpha
            ? `${form_data.background_colour},${form_data.background_colour_alpha}`
            : form_data.background_colour;

        var data = {
            format            : this.$el.find('.radio-box-select[data-val="format"] .radio-box.selected').data('val'),
            position          : this.$el.find('.position-select > div.selected').data('val'),
            size              : survey_size,
            align             : this.$el.find('.radio-box-select[data-val="align"] .radio-box.selected').data('val'),
            highlight_colour  : form_data.highlight_colour,
            complement_colour : form_data.complement_colour,
            has_background_colour,
            background_colour,
            display_powered_by: form_data.hide_powered_by.length === 0,
        };

        return data;
    },

    updateSettings: function() {
        var settings = this.getSettings();
        this.model.set(settings);
    },

    togglePositionSection: function() {
        var format = this.model.get('format');
        var visible = format === 'paged';

        this.$el.find('.position-section').toggle(visible);
    },

    toggleSizeSection: function() {
        var format = this.model.get('format');
        var position = this.model.get('position');
        var hidden_positions = ['top', 'bottom'];
        var visible = format === 'paged' && hidden_positions.indexOf(position) === -1;

        this.$el.find('.size-section').toggle(visible);
    },

    canRemovePoweredBy: function() {
        return Cache.account.hasFeature('powered_by') && !Cache.account.get('is_trial');
    },

    initialize: function() {
        this.listenTo(this.model, 'change:format', this.event_handlers.onFormatChange);
        this.listenTo(this.model, 'change:position', this.event_handlers.onPositionChange);
    },

    render: function() {
        var format = this.model.get('format');
        var position = this.model.get('position');
        var align = this.model.get('align');

        var content =
        '<div class="setting-title">Layout</div>' +

        '<div class="setting-subtitle">Format</div>' +
        '<div class="format radio-box-select radio-box-select-2" data-val="format">' +
            '<div class="radio-box" data-val="paged"><i class="fa-regular fa-rectangle-history"></i><span>Paged</span></div>' +
            '<div class="radio-box" data-val="pageless"><i class="fa-regular fa-scroll"></i><span>Pageless</span></div>' +
        '</div>' +

        '<div class="format-tips text-info text-medium margin-top-8">' +
            '<span data-val="paged">Only one question per page will be displayed.</span>' +
            '<span data-val="pageless">All questions will be displayed on a single page</span>' +
        '</div>' +

        '<div class="position-section">' +
            '<div class="divider-24"></div>' +

            '<div class="setting-subtitle">Position</div>' +
            '<div class="position-select">' +
                '<div data-val="top_left"></div>' +
                '<div data-val="top"></div>' +
                '<div data-val="top_right"></div>' +
                '<div data-val="left"></div>' +
                '<div data-val="center"></div>' +
                '<div data-val="right"></div>' +
                '<div data-val="bottom_left"></div>' +
                '<div data-val="bottom"></div>' +
                '<div data-val="bottom_right"></div>' +
            '</div>' +
            '<div class="position-tips text-info text-medium margin-top-8">The form will be displayed <span>' + position_text[position][0] + '</span> the <span>' + position_text[position][1] + '</span> of the screen</div>' +
        '</div>' +

        '<div class="size-section">' +
            '<div class="divider-24"></div>' +

            '<div class="setting-subtitle">Size (max width of content area)</div>' +
            '<input type="range" name="survey_size" class="full" min="1" max="5" step="1">' +
            '<div class="survey-size-text">' +
                '<div>Smaller</div>' +
                '<div>Small</div>' +
                '<div>Medium</div>' +
                '<div>Large</div>' +
                '<div>Larger</div>' +
            '</div>' +
        '</div>' +

        '<div class="divider-24"></div>' +

        '<div class="setting-subtitle">Alignment</div>' +
        '<div class="survey-alignment radio-box-select radio-box-select-2 radio-box-select-small" data-val="align">' +
            '<div class="radio-box radio-box-small" data-val="left"><i class="fa-regular fa-align-left"></i></div>' +
            '<div class="radio-box radio-box-small" data-val="center"><i class="fa-regular fa-align-center"></i></div>' +
        '</div>' +

        '<hr class="margin-top-28 margin-bottom-24">' +

        '<div class="setting-title">Colors</div>' +

        '<div class="setting-subtitle">Highlight Color</div>' +
        '<div>Used in buttons, links and more to highlight</div>' +
        '<div class="divider-12"></div>' +
        '<div class="position-relative">' +
            '<input type="text" class="colour solid compact short" name="highlight_colour">' +
            '<div class="colour-indicator"></div>' +
        '</div>' +

        '<div class="divider-28"></div>' +

        '<div class="setting-subtitle">Complementary Color</div>' +
        '<div>Used in text and icons on the highlight color</div>' +
        '<div class="divider-12"></div>' +
        '<div class="position-relative">' +
            '<input type="text" class="colour solid compact short" name="complement_colour">' +
            '<div class="colour-indicator"></div>' +
        '</div>' +

        '<div class="divider-28"></div>' +

        '<div class="setting-subtitle">Background Overlay</div>' +
        '<div class="divider-12"></div>' +
        '<div>' +
            '<input id="has_background_colour" type="checkbox" name="has_background_colour" value="1">' +
            '<label for="has_background_colour">Add background behind the form</label>' +
        '</div>' +
        '<div class="divider-12"></div>' +
        '<div class="flex-start background-colour">' +
            '<div class="position-relative">' +
                '<input type="text" class="colour solid compact short" name="background_colour">' +
                '<div class="colour-indicator"></div>' +
            '</div>' +
            '<div class="flex-start position-relative background-colour-alpha">' +
                '<input type="number" name="background_colour_alpha" min="0" max="100" class="solid compact">' +
                '<label>%</label>' +
            '</div>' +
        '</div>' +

        '<hr class="margin-top-28 margin-bottom-24">' +

        '<div class="flex-between-top">' +
            '<div>' +
                '<div class="setting-title">Powered by Userback</div>' +
                '<div><input type="checkbox" class="update-click" name="hide_powered_by" id="hide_powered_by" value="1"><label for="hide_powered_by" class="margin-top-6">Hide "Powered by Userback"</label></div>' +
            '</div>' +
            '<div>' +
                (this.canRemovePoweredBy() ? '' :
                '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
            '</div>' +
        '</div>';

        this.$el.html(content);

        if (position) {
            this.$el.find(`.position-select > div[data-val="${position}"]`).addClass('selected');
        }

        this.togglePositionSection();

        // hide the size slider for top/bottom
        this.toggleSizeSection();

        var survey_size = this.model.get('size');
        var survey_size_value = sizes.findIndex((item) => item === survey_size) + 1;

        var has_background_colour = this.model.get('has_background_colour');
        var background_colour = this.model.get('background_colour');
        var bg_colour = '#000000';
        var bg_colour_alpha = '50';

        if (background_colour) {
            // TODO: need to discuss how to store the 'background_color'. add a new column or separate it with comma
            var bg = background_colour.split(',');

            if (bg[0]) {
                bg_colour = bg[0];
            }

            if ( bg[1]) {
                bg_colour_alpha = bg[1];
            }
        }

        var can_remove_power_by = this.canRemovePoweredBy();

        var hide_powered_by = undefined;

        if (can_remove_power_by) {
            hide_powered_by = this.model.get('display_powered_by') ? [] : [1]
        } else {
            hide_powered_by = [];
        }

        Form.setData(this.$el, {
            highlight_colour : this.model.get('highlight_colour'),
            complement_colour : this.model.get('complement_colour'),
            has_background_colour: has_background_colour ? [1] : [],
            background_colour: bg_colour,
            background_colour_alpha: bg_colour_alpha,
            survey_size: survey_size_value,
            hide_powered_by:  hide_powered_by,
        });

        this.$el.find(`.format .radio-box[data-val="${format}"]`).addClass('selected');
        this.$el.find(`.format-tips span[data-val="${format}"]`).addClass('active');

        this.$el.find(`.survey-alignment .radio-box[data-val="${align}"]`).addClass('selected');

        if (has_background_colour) {
            this.$el.find('.background-colour').addClass('active');
        }

        // powered by
        if (!can_remove_power_by) {
            this.$el.find('[name=hide_powered_by]').prop('disabled', true);
        }

        return this;
    }
});
